import React, { memo } from 'react';
import { Skeleton, useMediaQueryContext } from '@fourthwall/components';
import * as S from '../styled';
export const SelectProductsListItemSkeleton = memo(() => {
    const media = useMediaQueryContext();
    return (React.createElement(S.Container, null,
        React.createElement(Skeleton.Shape, { width: 24, height: 24 }),
        React.createElement(Skeleton.Shape, { width: media.tablet ? 60 : 42, height: media.tablet ? 80 : 56 }),
        React.createElement(S.ProductInfo, null,
            React.createElement(Skeleton.Shape, { width: "50%", height: 24 }),
            !media.tablet && React.createElement(Skeleton.Shape, { width: 70, height: 24 })),
        media.tablet && React.createElement(Skeleton.Shape, { width: 70, height: 24 })));
});
